import { createSelector } from "reselect";
import { initialState } from "./reducer";

const reducerState = (state) => state.SiteSetting || initialState;

const makeSiteSettingSelectField = (field) =>
  createSelector(reducerState, (siteSettingState) => siteSettingState[field]);

export { reducerState, makeSiteSettingSelectField };
